<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { getAdminPanelContext } from "../context";

  const { showAddLicensesModalStore } = getAdminPanelContext();

  const onclick = () => {
    $showAddLicensesModalStore = true;
  };
</script>

<Button kind="tertiary" leadingIcon="fa-regular fa-cart-shopping" {onclick}
  >Add Licenses</Button
>
